import { IOfferScopeCrudModalLang, OFFER_SCOPE_CRUD_MODAL_LANG_KEY } from './interface.IOfferScopeCrudModalLang'
import { IOfferScopePageLang, OFFER_SCOPE_PAGE_LANG_KEY } from './interface.IOfferScopePageLang'
import { IOfferScopeListTableLang, OFFER_SCOPE_LIST_TABLE_LANG_KEY } from './interface.IOfferScopeListTableLang'

export * from './interface.IOfferScopeCrudModalLang'
export * from './interface.IOfferScopePageLang'
export * from './interface.IOfferScopeListTableLang'

export type IOfferScopeAllLang =
	& IOfferScopePageLang
	& IOfferScopeCrudModalLang
	& IOfferScopeListTableLang

export const OFFER_SCOPE_ALL_LANG_KEY: IOfferScopeAllLang = {
	...OFFER_SCOPE_CRUD_MODAL_LANG_KEY,
	...OFFER_SCOPE_LIST_TABLE_LANG_KEY,
	...OFFER_SCOPE_PAGE_LANG_KEY
}